// URL state (share) helpers: encode/decode calculator inputs to a query string.

const KEYS = [
  'a',  // loanAmount
  'r',  // interestRate
  't',  // tenure
  'tt', // tenureType
  'mE', // moratoriumEnabled
  'mM', // moratoriumMonths
  'mT', // moratoriumType
  'im', // interestMethod
  'ct', // chartType
  'ee', // extraEmi
  'pp', // prepayments (compact)
  'adv', // advanced (base64 json)
];

function b64EncodeJson(obj) {
  try {
    return typeof window !== 'undefined' ? window.btoa(unescape(encodeURIComponent(JSON.stringify(obj)))) : '';
  } catch (e) { return ''; }
}
function b64DecodeJson(str) {
  try {
    return JSON.parse(decodeURIComponent(escape(window.atob(str))));
  } catch (e) { return null; }
}

export function encodeStateToParams(state) {
  const params = new URLSearchParams();
  params.set('a', state.loanAmount);
  params.set('r', state.interestRate);
  params.set('t', state.tenure);
  params.set('tt', state.tenureType);
  params.set('mE', state.moratoriumEnabled ? 1 : 0);
  params.set('mM', state.moratoriumMonths);
  params.set('mT', state.moratoriumType);
  params.set('im', state.interestMethod);
  if (state.chartType) params.set('ct', state.chartType);
  params.set('ee', state.extraEmi || 0);
  if (state.prepayments && state.prepayments.length) {
    params.set('pp', state.prepayments.map((p) => `${p.month}-${p.amount}`).join('.'));
  }
  if (state.advanced) params.set('adv', b64EncodeJson(state.advanced));
  return params.toString();
}

export function decodeParamsToState(search) {
  const params = new URLSearchParams(search);
  if (!KEYS.some((k) => params.has(k))) return null;
  const num = (k, fallback) => (params.has(k) ? Number(params.get(k)) : fallback);
  const str = (k, fallback) => (params.has(k) ? params.get(k) : fallback);
  const state = {};
  if (params.has('a')) state.loanAmount = num('a');
  if (params.has('r')) state.interestRate = num('r');
  if (params.has('t')) state.tenure = num('t');
  if (params.has('tt')) state.tenureType = str('tt');
  if (params.has('mE')) state.moratoriumEnabled = params.get('mE') === '1';
  if (params.has('mM')) state.moratoriumMonths = num('mM');
  if (params.has('mT')) state.moratoriumType = str('mT');
  if (params.has('im')) state.interestMethod = str('im');
  if (params.has('ct')) state.chartType = str('ct');
  if (params.has('ee')) state.extraEmi = num('ee', 0);
  if (params.has('pp')) {
    state.prepayments = params.get('pp').split('.').map((s, i) => {
      const [month, amount] = s.split('-').map(Number);
      return { id: Date.now() + i, month, amount };
    });
  }
  if (params.has('adv')) {
    const adv = b64DecodeJson(params.get('adv'));
    if (adv) state.advanced = adv;
  }
  return state;
}

export function buildShareUrl(state) {
  if (typeof window === 'undefined') return '';
  const { origin, pathname } = window.location;
  return `${origin}${pathname}?${encodeStateToParams(state)}`;
}

export async function shareCalculation(state) {
  const url = buildShareUrl(state);
  const shareData = {
    title: 'EMIWise — my loan plan',
    text: 'Check out my EMI calculation on EMIWise',
    url,
  };
  if (typeof navigator !== 'undefined' && navigator.share) {
    try { await navigator.share(shareData); return { ok: true, method: 'native' }; }
    catch (e) { if (e.name === 'AbortError') return { ok: false, method: 'aborted' }; }
  }
  // Fallback: copy to clipboard
  try {
    await navigator.clipboard.writeText(url);
    return { ok: true, method: 'clipboard' };
  } catch (e) {
    return { ok: false, method: 'copy-failed', url };
  }
}
